import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const GitBasicsBlog = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">A Beginner’s Guide to Git: Understanding the Basics</h1>
          <p>
            Git is a powerful version control system used by developers worldwide to manage and track changes in their code. 
        Whether you're working on a personal project or collaborating with a team, Git helps ensure that your code remains organized and easily accessible. 
        In this blog, we’ll explore the basics of Git, its key features, and how you can get started.
          </p>
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image
                src="/graphics/images/git.png"
                alt="Git"
                fluid
              />
            </Col>
          </Row><br/>
          <h4>What is Git?</h4>
          <p>
            Git is a <strong>distributed version control system (DVCS)</strong> that enables multiple developers to work on the same project simultaneously. 
        Unlike traditional version control systems, Git allows each contributor to have a complete copy of the repository, making it easy to work offline and merge changes later.
          </p>
          <h4>Why Use Git?</h4>
          <ul>
            <li className="text-dark"><strong>Version Control</strong> – Keep track of changes and revert to previous versions if needed.</li>
            <li className="text-dark"><strong>Collaboration</strong> – Multiple developers can work on the same project without conflicts.</li>
            <li className="text-dark"><strong>Branching & Merging</strong> – Work on new features or bug fixes in isolated branches before merging.</li>
            <li className="text-dark"><strong>Backup & Recovery</strong> – Your code is safely stored in repositories, reducing the risk of data loss.</li>
            <li className="text-dark"><strong>Open-Source & Widely Used</strong> – Git is free to use and has strong community support.</li>
        </ul>

          <h4>Installing Git</h4>
          <p class="text-dark">To install Git, follow these steps based on your operating system:</p>
          <ul>
            <li class="text-dark"><strong>Windows</strong> – Download the Git installer from <a href="https://git-scm.com">git-scm.com</a> and follow the setup instructions.</li>
            <li class="text-dark"><strong>MacOS</strong> – Use Homebrew: <code>brew install git</code></li>
            <li class="text-dark"><strong>Linux</strong> – Use your package manager: <code>sudo apt install git</code> (Debian/Ubuntu) or <code>sudo dnf install git</code> (Fedora)</li>
        </ul>
          <p class="text-dark">After installation, verify it by running:</p>
        <pre>git --version</pre>

        <h4>Basic Git Commands</h4>

        <h5>1. Configuring Git</h5>
        <pre>git config --global user.name "Your Name"
    git config --global user.email "your.email@example.com"</pre>

        <h5>2. Initializing a Repository</h5>
        <pre>git init</pre>

        <h5>3. Cloning a Repository</h5>
        <pre>git clone &lt;repository-url&gt;</pre>

        <h5>4. Checking Repository Status</h5>
        <pre>git status</pre>

        <h5>5. Adding Changes</h5>
        <pre>git add &lt;file&gt;  # Add a specific file
    git add .       # Add all changes</pre>

        <h5>6. Committing Changes</h5>
        <pre>git commit -m "Your commit message"</pre>

        <h5>7. Pushing Changes</h5>
        <pre>git push origin main</pre>

        <h5>8. Pulling Updates</h5>
        <pre>git pull origin main</pre>

        <h5>9. Branching in Git</h5>
        <pre>git branch new-feature
    git checkout new-feature
    git checkout main
    git merge new-feature</pre>

        <h5>10. Viewing Commit History</h5>
        <pre>git log</pre>

        <h4>Using GitHub with Git</h4>
        <p class="text-dark">GitHub is a cloud-based Git repository hosting service. To push your local repository to GitHub:</p>
        <ol>
            <li class="text-dark">Create a new repository on GitHub.</li>
            <li class="text-dark">Add the remote repository:</li>
        </ol>
        <pre>git remote add origin &lt;repository-url&gt;</pre>
        <ol start="3">
            <li class="text-dark">Push your code:</li>
        </ol>
        <pre>git push -u origin main</pre>

        <h4>Conclusion</h4>
        <p class="text-dark">Git is an essential tool for developers and teams. Mastering Git commands can improve your workflow and help manage code efficiently. 
        Start practicing Git today, and soon, you'll be able to collaborate on projects with ease!</p>
        </Col>
        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color">Recent Post</h4>
            <RecentPost/>
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default GitBasicsBlog;